
import { ScrollView, HStack, VStack, View, Icon, ButtonText, ButtonIcon, Pressable, Button, Text, Image, Spinner } from "@gluestack-ui/themed"
import { Spacer } from 'native-base';
import React, { FunctionComponent } from 'react';
import { MaterialIcons, Ionicons, FontAwesome5, MaterialCommunityIcons } from "@expo/vector-icons";
import { onPatch } from 'mobx-state-tree';
import * as DocumentPicker from 'expo-document-picker';
import * as FileSystem from "expo-file-system"
import { ElementBase, IElementBaseProps, ModalFull, useInitializeElement } from '..';
import { checkIsValidRecord, createDynamicParms, getDisplayAndValue, getItemHeader, getItemTitle } from '../../utils/itemCommonFunctions';
import { conditionIsGo } from '../../utils/conditionIsGo';
import OpenFile from 'react-native-files-viewer';
import { FieldsList } from "../FieldsList";
import { Dimensions, Linking, StyleSheet, TouchableOpacity, FlatList } from "react-native";
import { useDebouncedCallback } from "use-debounce";
import { formatNumber, formatValueToDisplay, getContrastTextColor } from "../../utils/general";
import { ResizeMode, Video } from "expo-av";
import { glueStyles } from "../../configGlueStack/gluestack-ui.config";

export const SimpleListElement: FunctionComponent<IElementBaseProps> = ({ ...props }) => {
   
    const { itemsStore, statusStore, integrationsStore, element, payload, setPayload, checkAndSetPayload, errorList, setErrorList, modalVisible, setModalVisible,
        loading, setLoading } = useInitializeElement(props, false, /* parseValueFromPopulate */);
         console.log("init Simplelist ",element.name)
    const [isValidActiveRecord, setIsValidActiveRecord] = React.useState<boolean>(false);
    const [listRecords, setListRecords] = React.useState({ listToRender: <View></View>, lastUpdate: (new Date()).getTime() });
    const rowWidth = statusStore.windowDimensions.width - (statusStore.isLargeScreen && statusStore.hasSideBar ? 330 : 10);
    const cancelRecord = () => {
        setPayload({ ...payload, activeRecord: { idx: undefined, record: undefined } });
    }
    if (element.templateData.showInlineHorizontal == true) {
        console.log("i3g1pat10")
    } else
        element.templateData.showInlineHorizontal = false;

    //para mantener compatibilidad con funcionamiento anterior
    if (element.integration)
        element.integration.userMode = element.integration.userMode == undefined ? true : element.integration.userMode;

    const walkNodes = (nodes, record) => {
        nodes.forEach((f: any) => {
            let nodeValid = element.templateData.showInline && itemsStore.getErrorElement(f, null).valid;
            let val = itemsStore.loadConstValues(f) ?? null;
            record[f.id] = { value: val, valid: f.type == "group" || f.isArchived || nodeValid?.valid, type: f.type, templateData: { useAsTitle: f.templateData?.useAsTitle } }
            if (f.type == "select" && f.templateData.options.find(o => o.split("|")[0].includes("*"))) {
                record[f.id].value = f.templateData.options.find(o => o.split("|")[0].includes("*"));
                record[f.id].valid = true;
            }

            if (Array.isArray(f.nodes))
                walkNodes(f.nodes, record);
        });
    }

    const addRecord = () => {
        let record: any = {}
        walkNodes(element.nodes, record);
        setPayload({ ...payload, activeRecord: { idx: -1, record } });
    }

    const openRecord = (idx) => {
        function walk(nodes) {
            nodes.forEach((f: any) => {
                let nodeValid = itemsStore.getErrorElement(f, record[f.id]?.value);
                record2[f.id] = { url: record[f.id]?.url, value: record[f.id]?.value, valid: f.isArchived || nodeValid?.valid, type: f.type, templateData: { useAsTitle: f.templateData?.useAsTitle } }
                if (Array.isArray(f.nodes)) walk(f.nodes);
            });
        }
        let record: any = idx == -1 ? {} : { ...payload.value[idx] };
        let record2: any = {};
        walk(element.nodes);
        setPayload({ ...payload, activeRecord: { idx, record: record2 } });
    }

    const removeRecord = (idx) => {
        let records: any = (itemsStore.getPayloadElement(element.id, props.parentId)).value.slice(0);
        records.splice(idx, 1);
        checkAndSetPayload(records);
    }

    const saveRecord = () => {
        console.log("saveRecord")
        let records: any[] = [].concat((payload.value || []));
        let activeRecord = itemsStore.getPayloadElement(element.id, props.parentId);
        console.log(activeRecord)
        if (activeRecord?.activeRecord?.idx == -1) {
            records.push(activeRecord.activeRecord.record);
        } else {

            records[activeRecord.activeRecord.idx] = activeRecord.activeRecord.record;
        }

        checkAndSetPayload(records, { idx: undefined, record: undefined })

    }

    const processCSV = async (content) => {
        let records: any[] = [].concat(payload.value || []);
        let mustUpdate: boolean = false;
        content.split("\n").forEach((row: string) => {
            let cols: string[] = row.split("\t");
            let rowData: any = {};
            element.nodes.forEach((f: any, idx: number) => {
                rowData[f.id] = { value: cols[idx], valid: undefined, type: f.type }
            });
            mustUpdate = true;
            records.push(rowData);
        });
        if (mustUpdate) {
            checkAndSetPayload(records)
        }

    }
    const importFile = async () => {
        const result = await DocumentPicker.getDocumentAsync({ type: "text/*" });
        setLoading(true);
        if (result.type == "success" || result.canceled == false) {
            let fileUri = result.uri || result.assets[0].uri;
            if (fileUri.substring(0, 5) == "data:") {
                //base64
                let res = await fetch(fileUri);
                let blob = await res.blob();
                let reader = new FileReader();
                await reader.readAsText(blob, 'utf8');
                reader.onload = function () {
                    processCSV(reader.result)
                    setLoading(false);
                }
            } else {
                let content = await FileSystem.readAsStringAsync(fileUri)
                processCSV(content);
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    }

    const getInfo = async () => {
        setLoading(true);
        let dynamicParams = await createDynamicParms(element, itemsStore.getPayloadElement, props.parentId);
        let data = await integrationsStore.getIntegration(element.integration.id, dynamicParams);
        if (Array.isArray(data)) {
            let records: any[] = [];
            data.forEach((cols) => {
                let rowData: any = {};
                element.nodes.forEach((f: any, idx: number) => {
                    rowData[f.id] = { value: null, valid: undefined, type: f.type }
                });
                for (let key in element.integration.populateValues) {
                    var f = element.nodes.find((o) => {
                        return o.id == element.integration.populateValues[key]
                    });
                    if (f) {

                        let value = null;
                        let url = undefined;
                        let valid = undefined;
                        if (cols[key] != null && typeof (cols[key]) == "object") {
                            value = cols[key].value;
                            url = cols[key].url;
                            valid = cols[key].valid;
                        } else
                            value = cols[key] ? (cols[key]) : null;

                        rowData[f.id] = { value, valid, type: f.type, url }
                    }
                };
                records.push(rowData);
            });
            if (JSON.stringify(payload.value) != JSON.stringify(records))
                checkAndSetPayload(records);
        }
        setLoading(false);
    }

    const valueToDisplay = (type, value, field = undefined) => {
        try {
            if (value == undefined)
                return "";
            switch (type) {
                case "select":
                    value = getDisplayAndValue(value.toString()).display;
                    return "".concat(value || "")
                case "geo":
                    return value ? `${value.coords?.latitude},${value.coords?.longitude}` : ' ';
                case "checkbox":
                    return value ? "SI" : "NO";
                case "multiple":
                    if (!Array.isArray(value))
                        value = [value];
                    value = value.map(value2 => getDisplayAndValue(value2.toString()).display).join();
                    break;
                case "timestamp":
                    value = new Date(value).getYYYYMMddHHmmss();
                    return "".concat(value || "")
                case "date":
                    value = new Date(value).getYYYYMMdd();
                    return "".concat(value || "")
                case "time":
                    value = new Date(value).getHHmm();
                    return "".concat(value || "")
                case "number":
                    const {
                        forceDecimals = false,
                        maxDecimalsCount = 2,
                        thousandSeparator = false
                    } = field.templateData || {};
                    value = formatNumber(value,
                        forceDecimals ? maxDecimalsCount : null,
                        thousandSeparator ? "," : ""
                    );
                    break;
                case "text":
                    return "".concat(value || "")
            }
        } catch (e) {
            console.log(e);
        }
        return JSON.stringify(value);
    }

    const openMedia = (uri) => {
        if (uri)
            OpenFile?.openDoc(
                {
                    url: uri,
                    fileName: element.id || element.label,
                    cache: false,
                    // @ts-ignore
                    fileType: uri.substring(uri.lastIndexOf(".") + 1)
                },
                console.log
            );
    }
    const loadHeaders = (opts: [string]) => {
        console.log("loadHeaders");
        let records: any[] = [];
        for (const opt of opts) {
            let rowData: any = {};
            walkNodes(element.nodes, rowData)
            rowData[element.nodes[0].id].value = opt;
            records.push(rowData);
        }
        checkAndSetPayload(records)
    }
    const viewNodesList = (nodes: any, record: any, idx: number, elementId: string) => {
        return nodes?.map((elChild: any) => {
            const fieldId = elChild.id;
            const label = elChild.name || elChild.label;
            if (elChild.templateData?.hidden)
                return <></>;
            if (elChild.type == 'group') {
                return viewNodesList(elChild.nodes, record, idx, elChild.id);
            }
            
            if (elChild.type == "checkbox" && record[fieldId]?.value != true)
                return (<HStack  style={styles2.fieldWrapper} width={elChild.templateData?.width ? elChild.templateData?.width : "100%"} width={elChild.templateData?.width ? elChild.templateData?.width : "100%"} py={1} px={2} key={`record-${elementId}-${idx}-${fieldId}`}>
                    {elChild.templateData?.hidden_label ? <Text>NO</Text> : <Text style={{ fontWeight: "bold" }}>{label}: NO</Text>}
                </HStack>)

            if (record[fieldId]?.value && record[fieldId].value?.toString() != "") {
                let value = <></>;
                if (record[fieldId].type == "photo" && Array.isArray(record[fieldId].value)) {
                    value = record[fieldId].value?.map((photo: { uri: string }, idx: number) => {
                        return <Pressable onPress={() => { openMedia(photo.uri) }} key={`pressable-${elementId}-${idx}-${fieldId}`}>
                            <Image alt={`photo${fieldId}-${idx}`} key={`photo${fieldId}-${idx}`} source={{ uri: `${photo.uri}?refresh=${new Date().getTime()}` }} style={{ resizeMode: "contain", backgroundColor: "#000", marginTop: 2 }} width={statusStore.windowDimensions.width} height={statusStore.windowDimensions.height / 5} />
                        </Pressable>
                    });
                    return (<VStack  style={styles2.fieldWrapper} width={elChild.templateData?.width ? elChild.templateData?.width : "100%"} py={1} alignContent={"center"} key={`record-${elementId}-${idx}-${fieldId}`}>
                        <Text style={{ fontWeight: "bold" }}>{label} : </Text>
                        {value}
                    </VStack>)
                } else if (record[fieldId].type == "video" && record[fieldId].value) {
                    value = record[fieldId].value?.map((video: { uri: string }, idx: number) => {
                        return <Video alt={`video${fieldId}-${idx}`} key={`video${fieldId}-${idx}`} source={{ uri: `${video.uri}?refresh=${new Date().getTime()}` }} resizeMode={ResizeMode.CONTAIN} style={{ width: "100%", height: 150, maxHeight: statusStore.windowDimensions.height / 5, flex: 1, backgroundColor: "#000", marginTop: 2 }}
                            useNativeControls
                        />
                    });
                    return (<VStack style={styles2.fieldWrapper} width={elChild.templateData?.width ? elChild.templateData?.width : "100%"} py={1} alignContent={"center"} key={`record-${elementId}-${idx}-${fieldId}`}>
                        <Text style={{ fontWeight: "bold" }}>{label} : </Text>
                        {value}
                    </VStack>)
                } else if (record[fieldId].type == "sign" && record[fieldId].value) {
                    return (<VStack style={styles2.fieldWrapper} width={elChild.templateData?.width ? elChild.templateData?.width : "100%"} px={2} py={1} alignContent={"center"} key={`record-${elementId}-${idx}-${fieldId}`}>
                        <Text style={{ fontWeight: "bold" }}>{label} : </Text>
                        <Image alt={`sign${fieldId}-${idx}`} key={`photo${fieldId}-${idx}`} source={{ uri: `${record[fieldId].value}?refresh=${new Date().getTime()}` }} style={{ resizeMode: "contain", backgroundColor: "#fff", marginTop: 2 }} width={statusStore.windowDimensions.width} height={statusStore.windowDimensions.height / 6} />
                    </VStack>)
                } else if (record[fieldId].type == "docs" && Array.isArray(record[fieldId].value)) {
                    value = record[fieldId].value?.map((mediaName: { uri: string }, idx: number) => {
                        return <HStack><Pressable onPress={() => { openMedia(mediaName.uri) }}
                            style={{ minHeight: 50, flex: 1, flexDirection: "row", alignItems: "center", }}>
                            <Icon mx="2" as={MaterialCommunityIcons} name="file-eye-outline" size="md" /><Text>{(mediaName.name || mediaName.uri.substring(mediaName.uri.lastIndexOf("docs")))}</Text>
                        </Pressable></HStack>
                    });
                    return (<VStack style={styles2.fieldWrapper} width={elChild.templateData?.width ? elChild.templateData?.width : "100%"} py={1} alignContent={"center"} key={`record-${elementId}-${idx}-${fieldId}`}>
                        <Text style={{ fontWeight: "bold" }}>{label} : </Text>
                        {value}
                    </VStack>);
                } else if (record[fieldId].type == "number" ) {
                    value = <Text style={{ flexWrap: "wrap",fontWeight: elChild.templateData?.hidden_label ? "bold" : "normal" }}>{valueToDisplay(record[fieldId].type, record[fieldId].value, elChild).replaceAll('"',"")}</Text>
                } else
                    value = <Text style={{ flexWrap: "wrap", fontWeight: elChild.templateData?.hidden_label ? "bold" : "normal" }}>{valueToDisplay(record[fieldId].type, record[fieldId].value, elChild)}</Text>

                return (<HStack style={styles2.fieldWrapper} width={elChild.templateData?.width ? elChild.templateData?.width : "100%"} py={1} px={1} key={`record-${elementId}-${idx}-${fieldId}`}>
                    {elChild.templateData?.hidden_label ? <Text> </Text> : <Text style={{ fontWeight: "bold" }}>{label}: </Text>}
                    {value}
                </HStack>)
            }
        });
    }

    const recordView = (record: any, idx: number) => {
        const titleItem = getItemTitle(element.nodes, record, element.templateData.titleAsColumns, true);
        const widthRow = rowWidth  - (element.templateData?.lockDelete ? 0 : 30) - (element.templateData.hideItemNumber ? 40 : 40);
        const widthCol = (widthRow -40) / (element.templateData.titleAsColumns ? titleItem.length : 1);
        const itemNumberStart = element.templateData.itemNumberStart ?? 1;
        const itemNumber = (element.templateData.itemNumberStart ?? 1) + idx;
        const isEven = idx % 2 === 0;

        if (props.forReview) {
            return <VStack width={rowWidth} key={`SimpleList${element.id}-Row${idx}`} borderBottomWidth={1} borderBottomColor={"$light200"} px="0">
                <HStack  width={"100%"} >
                    <HStack alignItems={"center"} paddingTop={10} height={"$full"} backgroundColor={idx % 2 == 0 ? "$light200" : "$primary50"} justifyContent="center">
                        <Text fontSize={10} >{`${element.templateData.hideItemNumber == true ? '' : "".concat((idx + itemNumberStart).toString())}`}</Text>
                    </HStack>
                    <VStack px={0} flexWrap="wrap" width={"100%"} >
                        <VStack justifyContent="center" width={"100%"} >
                            {element.templateData.titleAsColumns != true ?
                                <HStack width={"100%"} backgroundColor={idx % 2 == 0 ? "$light200" : "$primary50"} justifyContent={"center"} borderBottomWidth={1}><Text textAlign={"center"} flexWrap={"wrap"} textBreakStrategy="simple" bold>{`${titleItem} `.toUpperCase()} </Text></HStack>
                                :
                                <HStack width={"100%"} backgroundColor={idx % 2 == 0 ? "$light200" : "$primary50"} justifyContent={"center"} borderBottomWidth={1}
                                >
                                    {titleItem.map((t, idx) =>
                                        <>
                                            <Text flexWrap={"wrap"} ellipsizeMode="tail" textBreakStrategy="simple">{t.value} </Text>
                                            {t.url ?
                                                <Pressable onPress={() => Linking.openURL(t.url)}>
                                                    <Icon name="launch" as={MaterialIcons} p={0} size={"md"} color={"$closed400"} />
                                                </Pressable>
                                                : <></>}
                                        </>)}
                                </HStack>
                            }
                        </VStack>
                        <View width={"100%"} flexWrap={"wrap"}  flexDirection={"row"} backgroundColor="white">{viewNodesList(element.nodes, record, idx, element.id)}</View>
                    </VStack>
                </HStack>
            </VStack>
        }
        let isValid = checkIsValidRecord(props.parentId, itemsStore, element, record);
        if (element.templateData.showInline) {
            const widthRow = rowWidth  - (element.templateData?.lockDelete ? 0 : 50) - (element.templateData.hideItemNumber ? 0 : 40);
            return <View key={`inline-${idx}`} style={[styles.inlineRow, { borderColor: isEven ? glueStyles.colors.primary300 : glueStyles.colors.primary50,backgroundColor:"white" }]}>
                {element.templateData.hideItemNumber == true ? <></> :
                    <View style={{ width: 35, backgroundColor: isEven ? glueStyles.colors.primary300 : glueStyles.colors.primary50, justifyContent: 'center', alignItems: 'center' }}>
                       
                        <Text style={{ fontSize: glueStyles.fontSizes.xs, color: getContrastTextColor(isEven ? glueStyles.colors.primary300 : glueStyles.colors.primary50) }}>#{itemNumber}</Text>
                    </View>
                }
                <View style={{ flexWrap: "wrap", width: widthRow,backgroundColor:"white" }} >
                    {payload.readOnly ? <></>:
                    <FieldsList horizonalView={element.templateData.showInlineHorizontal} scroll={true} key={`FieldsList${element.id}-Row${idx}-${(new Date()).getTime()}`} itemsStore={itemsStore}
                        fields={element.nodes}
                        forReview={props.forReview || payload.readOnly}
                        recordIdx={idx}
                        statusStore={statusStore}
                        parentId={element.id}
                    />}
                </View>
                {!element.templateData?.lockDelete && (
                    <TouchableOpacity style={styles.deleteButton} onPress={() => removeRecord(idx)}>
                        <Ionicons name="trash" size={20} color={glueStyles.colors.danger500} />
                    </TouchableOpacity>
                )}
            </View>

        }

        // MODO NORMAL (LISTA DE BOTONES PARA ABRIR MODAL)
        return (
            <View key={`SimpleList${element.id}-Row${idx}`} style={styles.rowWrapper}>
                <View style={styles.rowInner}>

                    {/* Botón Principal de la fila */}
                    <Pressable
                        onPress={() => openRecord(idx)}
                        style={({ pressed }) => [styles.pressableRow, pressed && styles.rowPressed]}
                    >
                        <View style={[styles.titleContainer, { width: widthRow  }]}>

                            {/* Columna de Icono de Validación y Número */}
                            <View style={[styles.statusCol, { borderRightWidth: element.templateData.titleAsColumns ? 1 : 0 }]}>
                                {/* Reemplazamos Icon de Gluestack por Icono directo de Expo para velocidad */}
                                {!isValid ? (
                                    <Ionicons name="information-circle" size={16} color={glueStyles.colors.danger400} />
                                ) : (
                                    <Ionicons name="caret-forward-outline" size={16} color={glueStyles.colors.success700} />
                                )}
                                <Text style={styles.itemNumberText}>
                                    {element.templateData.hideItemNumber ? '' : (idx + itemNumberStart)}
                                </Text>
                            </View>

                            {/* Título: Texto Simple o Columnas */}
                            {element.templateData.titleAsColumns !== true ? (
                                <Text style={styles.simpleTitleText} numberOfLines={2}>
                                    {String(titleItem).toUpperCase()}
                                </Text>
                            ) : (
                                <View style={styles.columnsWrapper}>
                                    {titleItem.map((t, i) => (
                                        <View key={`col-${i}`} style={[styles.columnItem, { width: widthCol }]}>
                                            <Text style={styles.columnText} numberOfLines={2}>{t.value}</Text>
                                            {t.url && (
                                                <Pressable onPress={() => Linking.openURL(t.url)} hitSlop={10}>
                                                    <MaterialIcons name="launch" size={16} color={glueStyles.colors.closed400} />
                                                </Pressable>
                                            )}
                                        </View>
                                    ))}
                                </View>
                            )}
                        </View>
                    </Pressable>


                    {/* Botón Eliminar */}
                    {!element.templateData?.lockDelete && (
                        <Pressable
                            style={styles.deleteButton}
                            onPress={() => removeRecord(idx)}
                            hitSlop={10}
                        >
                            <Ionicons name="trash" size={20} color={glueStyles.colors.danger500} />
                        </Pressable>
                    )}
                </View>
            </View>
        );
    }

    function headerView(header) {
        const widthRow = rowWidth  - (element.templateData?.lockDelete ? 0 : 30) - (element.templateData.hideItemNumber ? 40 : 40);
        const widthCol = (widthRow -40) / (element.templateData.titleAsColumns ? header.length : 1);
        return <VStack key={`SimpleList${element.id}-Header`} py={5} bgColor="$light200">
            <HStack alignItems={"center"} borderBottomWidth={1} borderBottomColor={"$light200"} px="2" py="2" >
                <HStack alignItems={"center"} py={2} maxWidth={rowWidth} maxH="200" overflow="hidden" >
                    <HStack width={46} borderRightWidth={1} borderRightColor={"$light300"} justifyContent="center"><Text></Text></HStack>
                    {header.map((t, idx) =>
                        <View key={"colValue".concat(idx)} width={widthCol} justifyContent={"center"} alignItems={"center"} borderRightWidth={1} borderRightColor={"$light300"}>
                            <Text numberOfLines={1} ellipsizeMode="tail" fontWeight={"bold"} flexWrap={"wrap"} textBreakStrategy="simple" textAlign="center">{t}</Text>
                        </View>)}
                </HStack>
            </HStack>
        </VStack>
    }
    function updListRecords(_lstRecords) {
        setListRecords({ listToRender: _lstRecords, lastUpdate: (new Date()).getTime() });
    }
    function reloadSetListRecords() {
        if ((payload.value || []).length > 0) {
            let title: any = [];
            if (props.forReview != true && element.templateData.titleAsColumns) {
                title = [headerView(getItemHeader(element.nodes, element.templateData.titleAsColumns))]
            }
            updListRecords(title.concat(
                payload.value.map((record, idx) => {
                    return recordView(record, idx);
                }))
            )
        } else
            updListRecords(<View></View>)
    }
    const getInfoDebouneced = useDebouncedCallback(getInfo, 10);
    const reloadSetListRecordsDebouneced = useDebouncedCallback(reloadSetListRecords, 10);

    React.useEffect(() => {
        const onResizeWindow = Dimensions.addEventListener('change', reloadSetListRecordsDebouneced);
        return () => onResizeWindow.remove();
    }, [])

    React.useEffect(() => {
        reloadSetListRecords();
    }, [payload.value, props.forReview])


    React.useEffect(() => {
        if ((payload.value || []).length > 0)
            if (element.templateData.showInline) {
                let value = itemsStore.getPayloadElement(element.id, props.parentId, props.recordIdx).value;
                checkAndSetPayload(value);
            }
    }, [props.forReview])

    React.useEffect(() => {
        try {
            if (props.forReview)
                return;
            console.log(element.type, "payload.useEffect");
            itemsStore.updPayloadElement(element.id, {inactiveGroup:false,...payload}, props.parentId);
            if ((payload.value || []).length == 0 && payload.readOnly != true)
                if (element.isDinamic != true && element.templateData.options?.length > 0) {
                    loadHeaders(element.templateData.options);
                } else {
                    if (element.validation?.required && element.integration?.id && element.integration.userMode == false) {
                        getInfo();
                    }
                }
            setModalVisible(payload.activeRecord && payload.activeRecord.idx != undefined);
        } catch { setModalVisible(false) }
    }, [payload]);

    React.useEffect(() => {
        setErrorList(itemsStore.getErrorElement(element, payload.value || []).errorList);
        if (modalVisible == true) {
            if (payload.activeRecord?.idx != undefined)
                setIsValidActiveRecord(checkIsValidRecord(props.parentId, itemsStore, element));
             let _disposerOnPatch = onPatch(itemsStore, patch => {
                console.log(element.type, "onPatch")
                if (patch.path.includes(element.id.concat("/activeRecord/record/")))
                    setIsValidActiveRecord(checkIsValidRecord(props.parentId, itemsStore, element, undefined));
            });
            return () => {
                _disposerOnPatch();
                _disposerOnPatch = undefined;
            } 
        } else {
            if (payload.readOnly != true && element.isDinamic == true || element.integration || element.templateData.showInline) {
                let _disposerOnPatch = onPatch(itemsStore, patch => {
                    if (element.isDinamic == true && !patch.path.includes(element.id.concat("/value/"))) {
                        console.log("modalHidden", patch.path);
                        let fields = [].concat((element.templateData.dynamicOptions || []).flatMap(require => require.conditions.flatMap(a => a.rules || a))).concat(element.requires || []);
                        if (element.templateData.dynamicOptions?.length > 0 && fields.some(f => patch.path.includes(f.fieldId))) {
                            const opts: [string] = conditionIsGo(element.templateData.dynamicOptions, itemsStore.itemActive.toJSON(), props.parentId);
                            if (Array.isArray(opts) && opts.length > 0) loadHeaders(opts);
                        }
                    }
                    if (element.integration && element.integration.userMode == false && element.integration.dynamicParams) {
                        Object.keys(element.integration.dynamicParams).forEach((v: any) => {
                            let myDependency = element.integration?.dynamicParams[v];
                            if (myDependency != element.id && patch.path.includes(myDependency))
                                getInfoDebouneced();
                        });
                    }
                    if (element.templateData.showInline) {
                        if (patch.path.includes(element.id.concat("/value/")) && patch.path.endsWith("/valid")) {
                            let payloadValue = itemsStore.getPayloadElement(element.id, props.parentId, props.recordIdx).value;
                            let errorElement = itemsStore.getErrorElement(element, payloadValue);
                            setErrorList(errorElement.errorList);
                        }
                    }
                });
                return () => {
                    _disposerOnPatch();
                    _disposerOnPatch = undefined;
                }
            }
        }
        return () => { }
    }, [modalVisible])

    const notValid = async (event)=>{
        console.log("vv")
        const retName:string[] =[];
        let isvalid: boolean =checkIsValidRecord(props.parentId, itemsStore, element,undefined, retName)
        const hint = retName.join(", ")
        statusStore.setHintMessage("Campos inválidos:", hint, );
        
    }

    const actionButtons = []
    if (loading || modalVisible)
        actionButtons.push(<Spinner key="lsSpinnerLoading" size="small" />)
    if (!props.forReview && !loading /* && !modalVisible*/) {
        if (element.templateData?.lockAdd != true)
            actionButtons.push(
                <Button width={40} height={40} p="$1"
                    variant="link"
                    key="btnAdd"
                    onPress={addRecord}
                >
                    <ButtonIcon as={Ionicons} name="add-circle-outline" fontWeight="$extrabold" size="lg" backgroundColor="white" color="$primary400" />
                </Button>
            );
        if (element.templateData?.allowImportCSV == true)
            actionButtons.push(
                <Button width={40} height={40} p="$1"
                    variant="link"
                    key="btnImportFile"
                    onPress={importFile}
                >
                    <ButtonIcon as={FontAwesome5} name="file-csv" fontWeight="$extrabold" size="lg" backgroundColor="white" color="$primary400" />
                </Button>
            );
        if (element.integration?.id)
            actionButtons.push(
                <Button width={40} height={40} p="$1"
                    variant="link"
                    key="btnImportIntegration"
                    onPress={getInfo}
                >
                    <ButtonIcon as={FontAwesome5} name="download" fontWeight="$extrabold" size="lg" backgroundColor="white" color="$primary400" />
                </Button>
            );
    }
    return (<><ElementBase boxStyle={{ padding: 0, paddingRight: 2, }}
        errors={errorList}
        leftButton={(<Icon size="lg" name="list" as={MaterialIcons} color={element.templateData?.textColor || undefined}/>)}
        rightButton={actionButtons}
        element={element} changedMe={listRecords.lastUpdate}
        forReview={props.forReview}>
        {!(modalVisible && payload.activeRecord?.record) ?
            ((Array.isArray(payload.value) && payload.value.length > 0) ?
                <View style={styles.container}>
                    {element.templateData?.partList || (payload.value.length > 50 && element.templateData.showInline) ? (
                        <FlatList
                            data={payload.value}
                            keyExtractor={(_, index) => `SimpleList${element.id}-Row${index}`}
                            renderItem={({ item, index }) => recordView(item, index)}
                            ListHeaderComponent={
                                props.forReview != true && element.templateData.titleAsColumns
                                    ? headerView(getItemHeader(element.nodes, element.templateData.titleAsColumns))
                                    : null
                            }
                            nestedScrollEnabled={true}
                            style={{ maxHeight: statusStore.windowDimensions.height * 0.8 }} // 80% del alto disponible
                            initialNumToRender={10}
                            maxToRenderPerBatch={10}
                            windowSize={5}
                        />
                    ) : (
                        listRecords.listToRender
                    )}
                    {payload.value.length > 6 && element.templateData?.lockAdd != true && props.forReview != true ?
                        <HStack alignItems="center" key="addRecordButton_bottom" >
                            <Button w="100%"
                                onPress={addRecord}>
                                <ButtonIcon as={Ionicons} name="add" fontWeight="$extrabold" size="lg" color="white" />
                                <ButtonText>AGREGAR REGISTRO</ButtonText>
                            </Button>
                        </HStack>
                        :
                        <></>}
                </View>
                : <></>)
            : null
        }
    </ElementBase>
        {modalVisible && payload.activeRecord && payload.activeRecord.idx!==undefined ? <ModalFull
            visible={modalVisible}
            title={payload.activeRecord.idx == -1 ? "Nuevo Registro #".concat((payload.value || []).length + 1) : "Registro #".concat((payload.activeRecord.idx + 1).toString())}
            closeButton_onPress={cancelRecord}
            footer={<>
                <Button
                    bgColor={isValidActiveRecord ? "$primary500" : "$primary900"}
                    borderRadius={0} w="100%"
                    onPress={(event: any) => {if(isValidActiveRecord) saveRecord(); else notValid(event);}}>
                    <ButtonIcon as={Ionicons} name="checkmark" fontWeight="$extrabold" size="lg" color={isValidActiveRecord ? "white" : "$light500"} />
                    <ButtonText color={isValidActiveRecord ? "white" : "$light500"}>Aceptar</ButtonText>
                </Button>
            </>
            }><View width="100%" height="100%" bgColor={"white"} alignSelf={"center"} borderWidth={1}>
                <ScrollView>
                    <VStack key="itemDetails-VStackItems" bg="$white" flex={1}>
                        {props.children}
                    </VStack>
                </ScrollView>
            </View>
        </ModalFull> : null}</>);

}


const styles = StyleSheet.create({
    container: { width: '100%', paddingLeft: 5, flex: 1 },
    listWrapper: {
        paddingLeft: 8,
        marginBottom: 5,
        backgroundColor: 'white',
        flex: 1
    },
    // Fila para modo "forReview" o lista simple
    rowContainer: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: glueStyles.colors.light200
    },
    // Indicador de número de item (#1, #2...)
    itemNumberCol: {
        width: 30,
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 10
    },
    itemNumberText: { fontSize: 10, color: '#666' },
    // Contenedor de contenido de la fila
    rowContent: { flex: 1, flexDirection: 'column' },
    // Estilo para modo Inline
    inlineRow: {
        flexDirection: 'row',
        alignItems: 'stretch',
        borderWidth: 2,
        marginBottom: 2,
        width: '100%',
        overflow: 'hidden'
    },
    // Cabecera de columnas
    headerContainer: {
        paddingVertical: 5,
        backgroundColor: glueStyles.colors.light200,
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#ddd'
    },
    headerCol: {
        justifyContent: 'center',
        alignItems: 'center',
        borderRightWidth: 1,
        borderRightColor: '#ccc'
    },
    headerText: { fontWeight: 'bold', fontSize: 12, textAlign: 'center' },
    // Botones de acción
    actionBtn: {
        width: 40,
        height: 40,
        justifyContent: 'center',
        alignItems: 'center'
    },
    rowWrapper: {
        width: '100%',
        backgroundColor: '#fff',
    },
    rowInner: {
        flexDirection: 'row',
        alignItems: 'center',
        borderBottomWidth: 1,
        borderBottomColor: glueStyles.colors.light200,
        paddingHorizontal: 2,
        paddingVertical: 2,
    },
    pressableRow: {
        width: '90%',
        flexDirection: 'row',
        alignItems: 'center',
    },
    rowPressed: {
        backgroundColor: 'rgba(0,0,0,0.05)',
    },
    titleContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        minHeight: 50,
    },
    statusCol: {
        width: 40,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 5,
        marginRight: 5,
        borderRightColor: glueStyles.colors.light300,
    },
    itemNumberText: {
        fontSize: glueStyles.fontSizes["2xs"],
        color: '#666',
    },
    simpleTitleText: {
        flex: 1,
        fontSize: glueStyles.fontSizes["xs"],
        color: '#333',
        flexWrap: 'wrap',
    },
    columnsWrapper: {
        flex: 1,
        flexDirection: 'row',
    },
    columnItem: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        borderRightWidth: 1,
        borderRightColor: glueStyles.colors.light300,
        paddingHorizontal: 2,
        minHeight: 40,
    },
    columnText: {
        fontSize: 12,
        textAlign: 'center',
        marginRight: 2,
    },
    deleteButton: {
        width: 40,
        justifyContent: 'center',
        alignItems:"flex-end",
    }
});

const styles2 = StyleSheet.create({
    wrapContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        padding: 2,
        width: "100%",
        marginTop: "auto"
    },
    fieldWrapper: {
        minWidth: 50,
        flexWrap: "wrap",
    },
    noBorderTop: {
        borderTopWidth: 0,
    }
});